module.exports = __webpack_public_path__ + "img/icons8-agreement-100.f160fc58.png";